import {
  animate,
  group,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const verticalCollapse = trigger('verticalCollapse', [
  transition(':enter', [
    query(':self', [
      style({ height: 0 }),
      animate('200ms ease-out', style({ height: '*' })),
    ]),
  ]),
  transition(':leave', [
    query(':self', [
      style({ height: '*' }),
      animate('200ms ease-out', style({ height: 0 })),
    ]),
  ]),
]);

export const showHide = trigger('showHide', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('100ms', style({ opacity: '*' })),
  ]),
  transition(':leave', [
    style({ opacity: '*' }),
    animate('100ms', style({ opacity: 0 })),
  ]),
]);

/** This used for slide up to off and slide down to show when toggle comment */
export const pdfShowHide = trigger('pdfShowHide', [
  transition(':enter', [
    style({ 'max-height': '0', padding: 0 }),
    animate(
      '200ms ease-out',
      style({ 'max-height': '0', padding: '*' }),
    ),
  ]),
  transition(':leave', [
    style({ height: '*' }),
    animate('350ms ease-out', style({ height: 0 })),
    animate('200ms ease-in', style({ padding: 0 })),
  ]),
]);

export const widthChange = trigger('widthChange', [
  state('auto', style({ width: 'auto' })),
  state('full', style({ width: '100%' })),
  transition('* => auto', [
    group([
      style({ width: '100%' }),
      animate('100ms', style({ width: 'auto' })),
      query(
        ':enter',
        [
          style({ opacity: 0 }),
          animate('200ms', style({ opacity: 1 })),
        ],
        { optional: true },
      ),
    ]),
  ]),
  transition('* => full', [
    group([
      style({ width: 'auto' }),
      animate('100ms', style({ width: '100%' })),
      query(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 })),
      ]),
    ]),
  ]),
]);

export const expandShrink = trigger('expandShrink', [
  state(
    'expand',
    style({
      padding: '0 0.625rem',
      width: '16.5rem',
    }),
  ),
  state(
    'shrink',
    style({
      padding: '0 0',
      width: '52px',
    }),
  ),
  transition('expand => shrink', [
    group([
      animate('100ms ease-in', style({ width: '*', padding: '*' })),
      query(':leave', [
        animate('100ms ease-in', style({ width: '*' })),
      ]),
    ]),
  ]),
  transition('shrink => expand', [
    group([
      animate('100ms ease-in', style({ width: '*', padding: '*' })),
      query(':enter', [animate('100ms')]),
    ]),
  ]),
]);
